export const SUPPORTED_SCHEMA_TYPES = [
    'Auto',
    'Article',
    'BlogPosting',
    'NewsArticle',
    'FAQPage',
    'HowTo',
    'LocalBusiness',
    'Organization',
    'Product',
    'Event',
    'Recipe',
    'QAPage',
    'Review',
    'WebPage',
    'WebSite',
    'BreadcrumbList',
    'ImageObject',
    'VideoObject',
    'Service',
    'Person',
    'Course',
    'JobPosting',
    'PodcastEpisode',
    'SoftwareApplication',
    'WebApplication',
    'ProfilePage',
    'CollectionPage',
    'ItemList',
];
export const SCHEMA_TYPE_DEFINITIONS = [
    {
        value: 'Auto',
        label: 'Auto-Detect',
        description: 'SuperSchema determines the best schema type for the page.',
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: false,
        autoPropose: false,
        aliases: ['Auto Detect', 'Auto-Detect', 'Automatic'],
    },
    {
        value: 'Article',
        label: 'Article',
        description: 'Editorial pages, guides, and long-form content.',
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: true,
        autoPropose: true,
        aliases: [],
    },
    {
        value: 'BlogPosting',
        label: 'Blog Post',
        description: 'A blog article or post with author and publishing context.',
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['BlogPost', 'Blog Post'],
    },
    {
        value: 'NewsArticle',
        label: 'News Article',
        description: 'News stories and press releases.',
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['News Article'],
    },
    {
        value: 'FAQPage',
        label: 'FAQ Page',
        description: 'Frequently asked questions and answers found on the page.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['FAQ', 'FAQ Page', 'FAQSchema', 'FAQ Schema'],
    },
    {
        value: 'HowTo',
        label: 'How-To Guide',
        description: 'Step-by-step instructional content.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['How To', 'How-To'],
    },
    {
        value: 'LocalBusiness',
        label: 'Local Business',
        description: 'A physical business location or local service provider.',
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['Local Business'],
    },
    {
        value: 'Organization',
        label: 'Organization',
        description: 'Company, brand, nonprofit, or organization identity.',
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: true,
        autoPropose: true,
        aliases: [],
    },
    {
        value: 'Product',
        label: 'Product',
        description: 'Product pages with product, offer, price, or commerce signals.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        autoPropose: true,
        aliases: [],
    },
    {
        value: 'Event',
        label: 'Event',
        description: 'Events with dates, attendance, location, or registration details.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        autoPropose: true,
        aliases: [],
    },
    {
        value: 'Recipe',
        label: 'Recipe',
        description: 'Recipe pages with ingredients and instructions.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        autoPropose: true,
        aliases: [],
    },
    {
        value: 'QAPage',
        label: 'Q&A Page',
        description: 'A page centered on one primary question and accepted answer.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['QA Page', 'Q&A'],
    },
    {
        value: 'Review',
        label: 'Review',
        description: 'Review or rating content with reviewer or rating signals.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        autoPropose: true,
        aliases: [],
    },
    {
        value: 'WebPage',
        label: 'Web Page',
        description: 'Core page identity, description, and relationship to the site.',
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['Webpage', 'Web Page'],
    },
    {
        value: 'WebSite',
        label: 'Website',
        description: 'Whole-site identity with publisher and site-level details.',
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['Website', 'Web Site'],
    },
    {
        value: 'BreadcrumbList',
        label: 'Breadcrumbs',
        description: 'Site navigation breadcrumbs for the current page.',
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['Breadcrumb', 'Breadcrumbs'],
    },
    {
        value: 'ImageObject',
        label: 'Images',
        description: 'Featured image and media metadata.',
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['Image', 'Images'],
    },
    {
        value: 'VideoObject',
        label: 'Videos',
        description: 'Video content and video metadata.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['Video', 'Videos'],
    },
    {
        value: 'Service',
        label: 'Service',
        description: 'Service offerings, professional services, consulting, or support pages.',
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: true,
        autoPropose: true,
        aliases: [],
    },
    {
        value: 'Person',
        label: 'Person',
        description: 'Individual people, authors, leaders, or professionals.',
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: true,
        autoPropose: true,
        aliases: [],
    },
    {
        value: 'Course',
        label: 'Course',
        description: 'Educational courses or training programs.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        autoPropose: true,
        aliases: [],
    },
    {
        value: 'JobPosting',
        label: 'Job Posting',
        description: 'Open jobs and hiring pages.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['Job', 'Job Posting'],
    },
    {
        value: 'PodcastEpisode',
        label: 'Podcast Episode',
        description: 'A single podcast episode with its show, host, and audio.',
        // Flexible, like Article and BlogPosting: this is a judgment about what
        // kind of content the page is, not an evidence-bearing rich-result type
        // such as Product or Review. The coverage engine has no audio signal to
        // gate on, so a strict policy would drop every episode the model
        // correctly identified, which is the behaviour this type was added to fix.
        evidencePolicy: 'flexible',
        requiresEvidence: false,
        allowManualAdd: true,
        autoPropose: true,
        aliases: ['Podcast Episode', 'Episode'],
    },
    {
        value: 'SoftwareApplication',
        label: 'Software App',
        description: 'A software product, app, or platform the page is about.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        // Explicit selection only until shadow logging shows the two-signal
        // detector is precise on real pages. Over-generation is our top complaint;
        // a new type does not get to volunteer itself on day one.
        autoPropose: false,
        aliases: ['Software Application', 'App', 'Software'],
    },
    {
        value: 'WebApplication',
        label: 'Web App',
        description: 'A browser-based application the page is about.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        autoPropose: false,
        aliases: ['Web Application'],
    },
    {
        value: 'ProfilePage',
        label: 'Profile Page',
        description: 'A page about one person, such as an author or team member.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        // Auto-enabled: the detector requires a profile route WITH a slug and a
        // heading that parses as a person's name, so it restates identity the page
        // already asserts rather than inferring anything new.
        autoPropose: true,
        aliases: ['Profile', 'Profile Page', 'Author Page'],
    },
    {
        value: 'CollectionPage',
        label: 'Collection Page',
        description: 'An index page that lists other pages, such as a blog or services index.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        // Explicit selection only until shadow logging shows the listing detector is
        // precise. An index page misread is not one wrong field, it is a whole
        // fabricated list of pages that may not exist.
        autoPropose: false,
        aliases: ['Collection Page', 'Collection', 'Index Page'],
    },
    {
        value: 'ItemList',
        label: 'Item List',
        description: 'A list of items shown on the page, usually links to other pages.',
        evidencePolicy: 'strict',
        requiresEvidence: true,
        allowManualAdd: true,
        autoPropose: false,
        aliases: ['Item List', 'List'],
    },
];
const SUPPORTED_SCHEMA_TYPE_SET = new Set(SUPPORTED_SCHEMA_TYPES);
const TYPE_BY_KEY = new Map();
const DEFINITION_BY_TYPE = new Map();
for (const definition of SCHEMA_TYPE_DEFINITIONS) {
    DEFINITION_BY_TYPE.set(definition.value, definition);
    TYPE_BY_KEY.set(schemaTypeKey(definition.value), definition.value);
    TYPE_BY_KEY.set(schemaTypeKey(definition.label), definition.value);
    for (const alias of definition.aliases) {
        TYPE_BY_KEY.set(schemaTypeKey(alias), definition.value);
    }
}
function schemaTypeKey(type) {
    return type.trim().toLowerCase().replace(/[\s_-]+/g, '');
}
export function normalizeSupportedSchemaType(type) {
    const schemaOrgMatch = type.match(/^https?:\/\/schema\.org\/([^/#?]+)$/);
    const localType = schemaOrgMatch ? schemaOrgMatch[1] : type;
    return TYPE_BY_KEY.get(schemaTypeKey(localType)) || null;
}
export function isSupportedSchemaType(type) {
    return SUPPORTED_SCHEMA_TYPE_SET.has(type);
}
export function canonicalSchemaTypeKey(type) {
    if (!type)
        return '';
    return schemaTypeKey(normalizeSupportedSchemaType(type) || type);
}
export function normalizeSchemaTypeList(types) {
    if (!types || types.length === 0)
        return undefined;
    const normalizedTypes = [];
    const seenKeys = new Set();
    for (const rawType of types) {
        const trimmedType = typeof rawType === 'string' ? rawType.trim() : '';
        if (!trimmedType)
            continue;
        const normalizedType = normalizeSupportedSchemaType(trimmedType) || trimmedType;
        const key = canonicalSchemaTypeKey(normalizedType);
        if (!seenKeys.has(key)) {
            seenKeys.add(key);
            normalizedTypes.push(normalizedType);
        }
    }
    return normalizedTypes.length > 0 ? normalizedTypes : undefined;
}
export function schemaTypeMatchesRequested(actualType, requestedTypes) {
    const normalizedRequestedTypes = normalizeSchemaTypeList(requestedTypes);
    if (!normalizedRequestedTypes || normalizedRequestedTypes.length === 0)
        return false;
    const requestedKeys = new Set(normalizedRequestedTypes.map(canonicalSchemaTypeKey));
    const matchesType = (type) => typeof type === 'string' && requestedKeys.has(canonicalSchemaTypeKey(type));
    if (Array.isArray(actualType)) {
        return actualType.some(matchesType);
    }
    return matchesType(actualType);
}
export function getSchemaTypeDefinition(type) {
    if (!type)
        return null;
    const normalized = normalizeSupportedSchemaType(type);
    return normalized ? DEFINITION_BY_TYPE.get(normalized) || null : null;
}
export function getSchemaTypeLabel(type) {
    return getSchemaTypeDefinition(type)?.label || type || 'Schema';
}
export function getSchemaTypeOptions() {
    return SCHEMA_TYPE_DEFINITIONS
        .filter((definition) => definition.allowManualAdd)
        .map(({ value, label, description, requiresEvidence }) => ({ value, label, description, requiresEvidence }));
}
export function isStrictSchemaType(type) {
    return getSchemaTypeDefinition(type)?.requiresEvidence === true;
}
export function canSchemaTypesCoexist(existingType, requestedType) {
    const existingKey = canonicalSchemaTypeKey(existingType);
    const requestedKey = canonicalSchemaTypeKey(requestedType);
    if (!existingKey || !requestedKey)
        return true;
    return existingKey !== requestedKey;
}
